/* LONGEVITY — SHARPE
   Cart drawer, quantity, accordions, sticky ATC.
   No framework. Uses the Cart AJAX API and the Section Rendering API. */

(function () {
  'use strict';

  var routes = window.themeRoutes || {};
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = window.themeMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts  = amount.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    return fmt
      .replace('{{amount}}', parts.join('.'))
      .replace('{{amount_no_decimals}}', parts[0])
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', parts[0]);
  }

  /* ---------- drawer ---------- */
  var drawer = $('#CartDrawer');
  var scrim  = $('#CartScrim');
  var lastFocus = null;

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('on');
    if (scrim) scrim.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    var close = $('[data-cart-close]', drawer);
    if (close) close.focus();
    document.addEventListener('keydown', onEsc);
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('on');
    if (scrim) scrim.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onEsc);
    if (lastFocus) lastFocus.focus();
  }
  function onEsc(e) { if (e.key === 'Escape') closeCart(); }

  /* ---------- re-render the drawer from the server ----------
     The Section Rendering API hands back the section wrapped in
     <div id="shopify-section-cart-drawer">, and that wrapper is what sits INSIDE our
     [data-cart-contents] host - so the response never contains the host itself.
     Matching on [data-cart-contents] found nothing, the swap was skipped without
     complaint, and the drawer kept its page-load markup while the header count moved
     on without it. Match the wrapper the server actually sends. */
  function refreshCart(sectionHtml) {
    var target = $('[data-cart-contents]');
    if (!target) return Promise.resolve();
    if (sectionHtml) {
      var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var section = parsed.querySelector('#shopify-section-cart-drawer');
      if (section) {
        target.innerHTML = section.outerHTML;
      } else {
        var host = parsed.querySelector('[data-cart-contents]');
        target.innerHTML = host ? host.innerHTML : parsed.body.innerHTML;
      }
      /* The badge is read off the markup we just installed, not from a second request
         for /cart.js. That request took about 700ms to land, and for those 700ms the
         drawer said one thing and the header said another. Same response, same tick,
         nothing to drift. */
      var total = $('[data-cart-total]', target);
      if (total) setCount(parseInt(total.getAttribute('data-cart-total'), 10) || 0);
      return Promise.resolve();
    }
    /* no-store: a cached /cart response would repaint the drawer with a cart the
       shopper has already moved on from. */
    return fetch(routes.cart + '?section_id=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) { return refreshCart(html); });
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    var live = $('#CartLive');
    if (live) live.textContent = n + ' item' + (n === 1 ? '' : 's') + ' in cart';
  }

  /* ---------- add to cart ---------- */
  function addToCart(id, qty, btn) {
    if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }
    return fetch(routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: qty || 1 }],
        sections: 'cart-drawer'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        return refreshCart(data.sections && data.sections['cart-drawer']);
      })
      /* Open once the drawer holds the right markup - refreshCart has already moved the
         badge with it. Opening only after a follow-up count request meant a hiccup on
         that request swallowed the whole add. */
      .then(function () { openCart(); })
      .catch(function (err) {
        var msg = $('[data-cart-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
        openCart();
      })
      .finally(function () { if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; } });
  }

  /* ---------- change a line ---------- */
  function changeLine(key, qty) {
    return fetch(routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return refreshCart(cart.sections && cart.sections['cart-drawer']);
      });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open) {
      e.preventDefault();
      openCart();
      /* Read the cart back on open rather than trusting the markup this page was
         served with - it may have been changed in another tab since. */
      refreshCart();
      return;
    }

    if (e.target.closest('[data-cart-close]') || e.target.id === 'CartScrim') { closeCart(); return; }

    var remove = e.target.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.dataset.lineRemove, 0); return; }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var input = $('input', step.parentNode);
      if (!input) return;
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
      input.value = next;
      if (step.dataset.lineKey) changeLine(step.dataset.lineKey, next);
      return;
    }
  });

  /* ---------- product form ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id  = form.querySelector('[name="id"]').value;
    var qty = form.querySelector('[name="quantity"]');
    addToCart(id, qty ? parseInt(qty.value, 10) : 1, form.querySelector('[type="submit"]'));
  });

  /* ---------- sticky add to cart ---------- */
  var sticky = $('#StickyAtc');
  if (sticky) {
    var anchor = $('[data-atc-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('on', !entries[0].isIntersecting);
      }, { rootMargin: '-40px 0px 0px 0px' }).observe(anchor);
    } else {
      sticky.classList.add('on');
    }
  }

  /* ---------- mobile nav ---------- */
  var burger = $('[data-nav-toggle]');
  if (burger) {
    burger.addEventListener('click', function () {
      var nav = $('#SiteNav');
      if (!nav) return;
      var open = nav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- header shadow on scroll ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Back/forward can restore this page from the bfcache long after the cart moved on. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCart();
  });

  window.theme = { openCart: openCart, closeCart: closeCart, addToCart: addToCart };
})();
